

import { AfterViewInit, Directive, ElementRef, Host, Optional, Renderer2 } from '@angular/core';

import { MwcButtonGroupComponent } from 'mwc/button';

@Directive({
  selector: '[mwc-button][mwc-dropdown]'
})
export class MwcDropdownButtonDirective implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    @Host() @Optional() private mwcButtonGroupComponent: MwcButtonGroupComponent,
    private elementRef: ElementRef
  ) {}
  ngAfterViewInit(): void {
    const parentElement = this.renderer.parentNode(this.elementRef.nativeElement);
    if (this.mwcButtonGroupComponent && parentElement) {
      this.renderer.addClass(parentElement, 'mwc-dropdown-button');
    }
  }
}
